// src/AuthLayout.jsx (atau src/pages/LoginPage.jsx)
import React, { useState } from "react";
import { useAuth } from "./context/AuthContext";
import { useForm } from "@mantine/form";
import { useNavigate, Link } from "react-router-dom"; 
import { getDashboardPath } from "./utils/authHelper";
import {
  TextInput,
  PasswordInput,
  Button,
  Paper,
  Title,
  Container,
  Alert,
  Text,
  Box,
  rem,
  LoadingOverlay
} from "@mantine/core";
import { IconAt, IconLock, IconAlertCircle, IconArrowLeft } from "@tabler/icons-react"; 

export default function AuthLayout() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // --- LOGIKA FORM ---
  const form = useForm({
    initialValues: { email: "admin@gizimon.com", password: "password" },
    validate: {
      email: (val) => (/^\S+@\S+$/.test(val) ? null : "Email tidak valid"),
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.email, values.password);
      const rawData = localStorage.getItem("userData");

      if (rawData) {
        const userObj = JSON.parse(rawData);
        const userRoleObj = userObj.role;
        const destination = getDashboardPath(userRoleObj);
        navigate(destination, { replace: true });
      } else {
        navigate("/landing");
      }
    } catch (err) {
      console.error("Error Login:", err);
      setError("Email atau Password salah.");
    }
    setLoading(false);
  };

  // --- RENDER TAMPILAN ---
  return (
    <div style={{ display: "flex", minHeight: "100vh", width: "100%" }}>
      
      {/* 1. BAGIAN KIRI: GAMBAR */}
      <Box
        visibleFrom="sm" 
        style={{
          flex: 1,
          position: "relative",
          backgroundImage: "url('https://assets.pikiran-rakyat.com/crop/0x0:0x0/1200x675/photo/2025/01/06/2553649856.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            padding: 60,
          }}
        >
          <Title order={1} c="white" style={{ fontSize: 42, lineHeight: 1.1 }}>
            GiziMon <br /> System
          </Title>
          <Text c="gray.3" mt="md" size="lg" style={{ maxWidth: 400 }}>
            Platform monitoring distribusi makanan bergizi untuk masa depan generasi yang lebih sehat.
          </Text>
        </div>
      </Box>

      {/* 2. BAGIAN KANAN: FORM LOGIN */}
      <Box
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f8f9fa",
          padding: 30,
          position: "relative" // Penting untuk tombol absolute
        }}
      >
        {/* --- TOMBOL KEMBALI (POJOK KANAN ATAS) --- */}
        <Button
            component={Link}
            to="/" 
            variant="subtle"
            color="gray"
            size="sm"
            leftSection={<IconArrowLeft size={16} />}
            style={{ 
                position: "absolute", 
                top: 20, 
                right: 20, // <--- UBAH DI SINI (Dulu 'left: 20')
                zIndex: 10
            }}
        >
            Kembali
        </Button>
        {/* ----------------------------------------- */}

        <Container size={420} my={40} w="100%">
          <Title ta="center" fw={900} style={{ color: '#228be6' }}>
            Selamat Datang
          </Title>
          <Text c="dimmed" size="sm" ta="center" mt={5}>
            Masuk untuk mengelola data distribusi
          </Text>

          <Paper withBorder shadow="xl" p={30} mt={30} radius="md" pos="relative">
            <LoadingOverlay visible={loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
            
            <form onSubmit={form.onSubmit(handleSubmit)}>
              
              {error && (
                <Alert
                  icon={<IconAlertCircle size={16} />}
                  title="Gagal Masuk"
                  color="red"
                  variant="light"
                  mb="md"
                  withCloseButton
                  onClose={() => setError(null)}
                >
                  {error}
                </Alert>
              )}

              <TextInput
                label="Email"
                placeholder="admin@gizimon.com"
                required
                leftSection={<IconAt style={{ width: rem(16), height: rem(16) }} />}
                {...form.getInputProps("email")}
              />
              
              <PasswordInput
                label="Password"
                placeholder="Password Anda"
                required
                mt="md"
                leftSection={<IconLock style={{ width: rem(16), height: rem(16) }} />}
                {...form.getInputProps("password")}
              />

              <Button type="submit" fullWidth mt="xl" size="md">
                Masuk Dashboard
              </Button>
              
            </form>
          </Paper>

          <Text ta="center" mt="lg" c="dimmed" size="xs">
            &copy; 2025 GiziMon Application. All rights reserved.
          </Text>
        </Container>
      </Box>
    </div>
  );
}